var _rect, _rect2, _path, _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimSupportbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 335,
    height: 120,
    viewBox: "0 0 335 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15174_66656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 335,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 335,
    height: 120,
    rx: 11,
    fill: "#E9F7EF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 334,
    height: 119,
    rx: 10.5,
    stroke: "url(#paint0_linear_15174_66656)",
    strokeOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15174_66656)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M273.613 46.5209C278.674 43.599 282.435 38.9065 284.072 33.4777C285.706 28.0484 285.083 22.3248 282.337 17.567C279.59 12.8091 274.944 9.40831 269.425 8.10883C263.905 6.81218 257.961 7.72308 252.9 10.6449C247.839 13.5668 244.078 18.2593 242.441 23.6881C240.807 29.1174 241.429 34.841 244.176 39.5988C246.923 44.3567 251.568 47.7575 257.088 49.057C262.608 50.3536 268.552 49.4427 273.613 46.5209ZM258.079 19.6149C260.609 18.154 263.58 17.6982 266.341 18.3461C269.101 18.9965 271.422 20.6967 272.796 23.0757C274.169 25.4546 274.481 28.3152 273.664 31.0305C272.845 33.7453 270.965 36.0904 268.434 37.5514C265.904 39.0123 262.933 39.4681 260.172 38.8202C257.412 38.1698 255.091 36.4696 253.717 34.0906C252.344 31.7117 252.032 28.8511 252.849 26.1358C253.668 23.421 255.548 21.0759 258.079 19.6149ZM276.202 51.0049C269.876 54.6568 265.173 60.5213 263.129 67.3087C261.083 74.0956 261.864 81.2498 265.297 87.1964L273.065 100.65C273.751 101.839 274.912 102.689 276.293 103.014C277.672 103.34 279.159 103.111 280.424 102.381L318.584 80.3489C319.848 79.6189 320.79 78.4454 321.197 77.0882C321.607 75.73 321.451 74.2998 320.765 73.1111L312.997 59.6571C309.564 53.7105 303.758 49.4569 296.858 47.8354C289.958 46.2115 282.527 47.353 276.202 51.0049ZM308.635 74.1326L280.015 90.6568L274.837 81.6888C272.062 76.8825 272.226 70.8654 275.266 65.9071C278.306 60.9465 283.76 57.7979 289.576 57.6448C295.39 57.4912 300.683 60.358 303.458 65.1643L308.635 74.1326ZM269.939 -58.9849L184.08 -9.41436C179.019 -6.4925 175.259 -1.79995 173.623 3.62786C171.987 9.05808 172.61 14.7817 175.356 19.5395L253.028 154.071C255.775 158.829 260.421 162.23 265.942 163.528C271.46 164.826 277.404 163.915 282.465 160.993L368.324 111.423C373.385 108.501 377.145 103.808 378.781 98.3806C380.417 92.9504 379.794 87.2268 377.047 82.4689L299.375 -52.0628C296.628 -56.8207 291.983 -60.2215 286.462 -61.52C280.944 -62.8176 275 -61.9067 269.939 -58.9849ZM367.506 87.9771C368.879 90.356 369.191 93.2166 368.374 95.932C367.555 98.6468 365.675 100.992 363.145 102.453L277.286 152.023C274.756 153.484 271.784 153.94 269.024 153.292C266.264 152.642 263.942 150.942 262.569 148.563L184.897 14.0308C183.523 11.652 183.212 8.79134 184.028 6.07597C184.848 3.36116 186.728 1.01609 189.258 -0.444866L275.117 -50.0154C277.647 -51.4763 280.618 -51.9321 283.379 -51.2842C286.139 -50.6338 288.461 -48.9336 289.834 -46.5547L367.506 87.9771ZM316.182 109.238C316.641 109.722 316.977 110.304 317.165 110.941C317.862 112.155 318.019 113.614 317.599 114.997C316.684 117.742 313.757 119.432 310.921 118.853C309.514 118.524 308.329 117.659 307.626 116.449C307.168 115.967 306.832 115.385 306.643 114.746C306.552 114.066 306.628 113.367 306.863 112.704C307.731 109.926 310.7 108.212 313.541 108.848C314.456 108.715 315.377 108.85 316.182 109.238Z",
    fill: "#297166",
    stroke: "#297166",
    strokeWidth: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3911,
    cy: 152.5,
    r: 106.5,
    fill: "#008633",
    fillOpacity: 0.05
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15174_66656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -74,
    y: 46,
    width: 214,
    height: 213
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3911,
    cy: 152.5,
    r: 106.5,
    fill: "#008633",
    fillOpacity: 0.7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15174_66656)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.3911,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint1_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.9556,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint2_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.52,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint3_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.08398,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint4_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -0.351562,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint5_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -8.78711,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint6_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -17.2227,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint7_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -25.6582,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint8_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -34.0942,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint9_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -42.5298,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint10_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -50.9653,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint11_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -59.4009,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint12_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -67.8364,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint13_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -76.2725,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint14_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -84.708,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint15_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -93.1436,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint16_linear_15174_66656)",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -101.579,
    cy: 152.5,
    r: 106.4,
    stroke: "url(#paint17_linear_15174_66656)",
    strokeWidth: 0.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15174_66656",
    x1: -4.7111e-7,
    y1: 3,
    x2: 263.949,
    y2: 210.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57B079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7EDD7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15174_66656",
    x1: 126.84,
    y1: 215.147,
    x2: -20.903,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_15174_66656",
    x1: 118.404,
    y1: 215.147,
    x2: -29.3386,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_15174_66656",
    x1: 109.969,
    y1: 215.147,
    x2: -37.7741,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_15174_66656",
    x1: 101.533,
    y1: 215.147,
    x2: -46.2101,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_15174_66656",
    x1: 93.097,
    y1: 215.147,
    x2: -54.6457,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_15174_66656",
    x1: 84.6614,
    y1: 215.147,
    x2: -63.0812,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_15174_66656",
    x1: 76.2259,
    y1: 215.147,
    x2: -71.5168,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_15174_66656",
    x1: 67.7903,
    y1: 215.147,
    x2: -79.9523,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_15174_66656",
    x1: 59.3543,
    y1: 215.147,
    x2: -88.3884,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_15174_66656",
    x1: 50.9187,
    y1: 215.147,
    x2: -96.8239,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_15174_66656",
    x1: 42.4832,
    y1: 215.147,
    x2: -105.259,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_15174_66656",
    x1: 34.0476,
    y1: 215.147,
    x2: -113.695,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_15174_66656",
    x1: 25.6121,
    y1: 215.147,
    x2: -122.131,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_15174_66656",
    x1: 17.1761,
    y1: 215.147,
    x2: -130.567,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_15174_66656",
    x1: 8.74051,
    y1: 215.147,
    x2: -139.002,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_15174_66656",
    x1: 0.304963,
    y1: 215.147,
    x2: -147.438,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_15174_66656",
    x1: -8.13058,
    y1: 215.147,
    x2: -155.873,
    y2: 152.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008633",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimSupportbg);
export default __webpack_public_path__ + "static/media/claimSupportbg.e770a6d9210c5e7f2d88163838ce9ece.svg";
export { ForwardRef as ReactComponent };